// Onboarding tour step definitions for Shepherd.js

export const tourSteps = [
  {
    id: 'welcome',
    title: 'Welcome to Unplug!',
    text: `<p>Let's take a quick tour to help you get started.</p>
           <p>You'll learn how to:</p>
           <ul style="margin: 0.5rem 0; padding-left: 1.25rem;">
             <li>Request and manage leave</li>
             <li>Set up your team</li>
             <li>Configure your workspace</li>
           </ul>`,
    buttons: [
      { text: 'Skip Tour', action: function() { this.cancel(); }, secondary: true },
      { text: 'Start Tour', action: function() { this.next(); } }
    ]
  },
  {
    id: 'dashboard',
    attachTo: { element: '.bento-grid', on: 'bottom' },
    title: 'Your Dashboard',
    text: 'This is your command center. See your leave balances, upcoming absences, and team calendar at a glance.',
    buttons: [
      { text: 'Back', action: function() { this.back(); }, secondary: true },
      { text: 'Next', action: function() { this.next(); } }
    ]
  },
  {
    id: 'requests',
    attachTo: { element: '.bento-top-nav-center a[href="/requests"]', on: 'bottom' },
    title: 'Leave Requests',
    text: 'Click here to request time off or manage pending requests. As an admin, you can approve or reject team requests.',
    buttons: [
      { text: 'Back', action: function() { this.back(); }, secondary: true },
      { text: 'Next', action: function() { this.next(); } }
    ]
  },
  {
    id: 'team',
    attachTo: { element: '.bento-top-nav-center a[href="/team"]', on: 'bottom' },
    title: 'Team Management',
    text: 'Manage your team members here. Assign roles, set managers, and organize into departments.',
    buttons: [
      { text: 'Back', action: function() { this.back(); }, secondary: true },
      { text: 'Next', action: function() { this.next(); } }
    ]
  },
  {
    id: 'settings',
    attachTo: { element: '.bento-top-nav-center a[href="/settings"]', on: 'bottom' },
    title: 'Workspace Settings',
    text: `<p><strong>Important!</strong> Configure these before your team starts:</p>
           <ul style="margin: 0.5rem 0; padding-left: 1.25rem;">
             <li>Departments & approvers</li>
             <li>Leave types & entitlements</li>
             <li>Locations & public holidays</li>
           </ul>`,
    buttons: [
      { text: 'Back', action: function() { this.back(); }, secondary: true },
      { text: 'Next', action: function() { this.next(); } }
    ]
  },
  {
    id: 'planner',
    attachTo: { element: '.bento-top-nav-center a[href="/wallchart"]', on: 'bottom' },
    title: 'Planner',
    text: 'View all team absences in a visual calendar. Great for spotting coverage gaps and planning ahead.',
    buttons: [
      { text: 'Back', action: function() { this.back(); }, secondary: true },
      { text: 'Next', action: function() { this.next(); } }
    ]
  },
  {
    id: 'complete',
    title: "You're All Set!",
    text: `<p>You're ready to start using Unplug!</p>
           <p style="margin-top: 0.75rem;"><strong>Recommended next steps:</strong></p>
           <ol style="margin: 0.5rem 0; padding-left: 1.25rem;">
             <li>Go to Settings → Departments to set up your team structure</li>
             <li>Import your team from Slack</li>
             <li>Configure public holidays for your locations</li>
           </ol>
           <p style="margin-top: 0.75rem;">Need help? Visit the <a href="/help" style="color: var(--primary);">Help Center</a> anytime.</p>`,
    buttons: [
      { text: 'Finish', action: function() { this.complete(); } }
    ]
  }
];
